




























































import firebase from 'firebase/app'
import {
  Vue, Component, Prop, Watch, Mixins, Emit,
} from 'vue-property-decorator'
import dayjs from 'dayjs'
import { includes } from 'ramda'
import {
  update, field, collection, get, query, where, set, add,
} from 'typesaurus'
import {
  getModule,
} from 'vuex-module-decorators'
import { db } from '../../firebase/init'
import MainMixin from '../../mixins/MainMixin'
import EventBus from '../../event-bus'
import {
  UserNoteType, UserType, UserCollection, UserNotesCollection,
} from '../../types'
import LocationStore from '../../store/modules/location'

// const userNotes = collection<UserNoteType>('userNotes')
// const users = collection<UsersType>('users')

@Component({
  // firestore() {
  //   return {
  //     allNotes: db.collection('userNotes'),
  //   }
  // },
  components: {
  },
})
export default class ViewUser extends Mixins(MainMixin) {
  @Prop() user!:UserType

  @Prop({ default: false }) outlined!:boolean

  @Prop({ default: false }) tile!:boolean

  isManager = false

  isActive = true

  showAddNoteField = false

  noteText = ''

  loading = false

  dayjs = dayjs

  updateDialog = false

  managerLoading = false

  activeLoading = false

  allNotes:UserNoteType[]|null = null

  LocationStore = getModule(LocationStore)

  async addNote() {
    if (!this.user || typeof this.user.id !== 'string') return false
    this.loading = true
    const note:UserNoteType = {
      user: this.user.id,
      created: new Date(),
      location: this.LocationStore.data.name,
      group: this.LocationStore.data.group,
      manager: this.$store.getters.uid,
      note: this.noteText,
    }
    await add(UserNotesCollection, note)
    this.loading = false
    this.noteText = ''
    this.showAddNoteField = false
    this.$toast.success('Note Successfully Added')
    return true
  }

  async updateManager() {
    console.log(' now its: ', this.isManager)
    this.managerLoading = true
    if (this.isManager) {
      await db.collection('users').doc(this.user.id).update({
        authTags: firebase.firestore.FieldValue.arrayUnion(`${this.LocationStore.data.group}-manager`),
      })
      this.isManager = false
    } else {
      await db.collection('users').doc(this.user.id).update({
        authTags: firebase.firestore.FieldValue.arrayRemove(`${this.LocationStore.data.group}-manager`),
      })
      this.isManager = true
    }
    this.managerLoading = false
    this.$toast.success(`User ${this.user.firstName} ${this.user.lastName} is ${this.isManager ? 'Now' : 'No Longer'} a Manager.`)
  }

  async sendPasswordReset() {
    firebase.auth().sendPasswordResetEmail(this.user.email)
      .then((r) => {
        console.log('Success', r)
        this.$toast.success(`Password reset email sent to ${this.user.email}`)
      }).catch((error) => {
        console.log('Error', error)
        this.$toast.error('Error sending password reset email, please contact support')
      })
  }

  async updateActive() {
    console.log(' now its: ', this.isManager)
    this.activeLoading = true
    if (!this.isActive) {
      await db.collection('users').doc(this.user.id).update({
        authTags: firebase.firestore.FieldValue.arrayUnion(`${this.LocationStore.data.group}-inactive`),
      })
      this.isActive = false
    } else {
      await db.collection('users').doc(this.user.id).update({
        authTags: firebase.firestore.FieldValue.arrayRemove(`${this.LocationStore.data.group}-inactive`),
      })
      this.isActive = true
    }
    this.activeLoading = false
    this.$toast.success(`User ${this.user.firstName} ${this.user.lastName} is ${this.isActive ? 'Now' : 'No Longer'} Active.`)
  }

  mounted() {
    if (includes(`${this.$store.getters.group}-manager`, this.user.authTags)) this.isManager = true
    if (includes(`${this.$store.getters.group}-inactive`, this.user.authTags)) this.isActive = false
    this.$bind('allNotes', db.collection('userNotes').where('user', '==', this.user.id).orderBy('created', 'desc'))
  }
}
